import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Popover from 'react-popover'
import i18next from 'i18next'
import NoteQuotes from 'app/components/NoteQuotes'
import { bc as MentionBC } from 'app/components/MentionTextArea/MentionTextArea'

import './styles.scss'

// Needs for do not close the popover when mention users in story
const MentionTextAreaClasses = [
  `${MentionBC}__user`,
  `${MentionBC}__fullname`,
  `${MentionBC}__user selected`,
  `${MentionBC}__fullname selected`,
]

const baseClass = 'time-line-dot'

class Dot extends Component {
  static propTypes = {
    proTrackName: PropTypes.string,
    activity: PropTypes.object,
    isMobile: PropTypes.bool,
    currentDay: PropTypes.number,
  }

  state = {
    isOpenNoteQuote: false,
  }

  render() {
    const {
      isStoryActivatedForOrganization,
      proTrackName,
      activity: {
        activityId,
        userActivityId,
        actionType,
        name,
        proQuote,
        proQuoteAuthor,
        description,
        question,
        isFavorite,
        hasStory,
      },
      currentDay,
      isMobile,
      limit,
      index,
    } = this.props

    const isDotReached = currentDay >= index
    const currentDot = currentDay === index
    const notDone = ['commit', 'skipped', 'didnot'].includes(actionType) || (!actionType && isDotReached)
    const did = actionType === 'did'
    const isShowStoryForm = !hasStory && isStoryActivatedForOrganization && question && did

    return (
      <Popover
        isOpen={this.state.isOpenNoteQuote}
        preferPlace="above"
        onOuterAction={event => {
          if (!MentionTextAreaClasses.includes(event.target.className)) {
            this.setState({ isOpenNoteQuote: false })
          }
        }}
        enterExitTransitionDurationMs={800}
        refreshIntervalMs={600}
        className={cn(`${baseClass}__tip-arrow`, {
          [`${baseClass}__tip-arrow--not-done`]: notDone,
          [`${baseClass}__tip-arrow--did`]: did,
        })}
        body={
          <NoteQuotes
            activityId={activityId}
            proTrackName={proTrackName}
            activityDay={index}
            activityTitle={name}
            proQuote={proQuote}
            proQuoteAuthor={proQuoteAuthor}
            description={description}
            isActivityFavorite={isFavorite}
            isShowStoryForm={isShowStoryForm}
            question={question}
            userActivityId={userActivityId}
            className={cn(`${baseClass}__note-quotes`, {
              [`${baseClass}__note-quotes--not-done`]: notDone,
              [`${baseClass}__note-quotes--did`]: did,
            })}
          />
        }
        tipSize={7}
      >
        <div className={`${baseClass}__wrapper`} style={{ width: `${100 / limit}%` }}>
          <div
            className={cn(`${baseClass}__dot`, {
              [`${baseClass}__dot--not-done`]: notDone,
              [`${baseClass}__dot--did`]: did,
              [`${baseClass}__dot--not-completed`]: !actionType && !isDotReached && !currentDot,
              [`${baseClass}__dot--current`]: currentDot,
              [`${baseClass}__dot--current__${i18next.language}`]: i18next.language && currentDot,
            })}
            onClick={() => isDotReached && this.setState({ isOpenNoteQuote: !this.state.isOpenNoteQuote })}
          >
            {isMobile && index}
          </div>
          {!isMobile && <div className={`${baseClass}__day`}>{index}</div>}
          {currentDot && <div className={`${baseClass}__white-border`} />}
        </div>
      </Popover>
    )
  }
}

export default Dot
